import { queryOptions } from '@tanstack/react-query';
import { restaurantApi } from './restaurant-api';

/** Query-key factory + query-options for restaurant reads. */
export const restaurantKeys = {
  all: ['restaurants'] as const,
  details: () => [...restaurantKeys.all, 'detail'] as const,
  detail: (id: string) => [...restaurantKeys.details(), id] as const,
};

export const restaurantQueries = {
  detail: (id: string, enabled = true) =>
    queryOptions({
      queryKey: restaurantKeys.detail(id),
      queryFn: () => restaurantApi.detail(id),
      enabled: enabled && Boolean(id),
    }),
};
